module.exports = window.getCLodop;


//////////////////
// WEBPACK FOOTER
// external "window.getCLodop"
// module id = 1871
// module chunks = 1